import { motion } from "framer-motion";

const clients = [
  { name: "Caffe Moak", initials: "CM" },
  { name: "Caffe Aiello", initials: "CA" },
  { name: "Orografie", initials: "OR" },
  { name: "Webidoo", initials: "WB" },
  { name: "Capua 1880", initials: "C8" },
  { name: "Giba Design", initials: "GD" },
];

export default function ClientLogos() {
  return (
    <section data-testid="client-logos-section" className="py-16 bg-white border-t border-slate-100">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <p className="text-xs font-medium text-slate-400 uppercase tracking-wider text-center mb-10">
          Alcuni dei nostri clienti e partner
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {clients.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="flex items-center gap-3 group"
              data-testid={`client-logo-${i}`}
            >
              <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center group-hover:bg-[#1B4332] transition-colors duration-300">
                <span className="text-xs font-bold text-slate-500 group-hover:text-white transition-colors duration-300">
                  {c.initials}
                </span>
              </div>
              <span className="text-sm font-medium text-slate-400 group-hover:text-slate-700 transition-colors duration-300">
                {c.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
